module.exports = "/_next/static/images/CollectImage@2x-eca12c946f5f6b14a04a3e1144a4aac1.webp";